// import "./css/index.pcss";
// import "./css/vendor/tinymce.pcss"
import "./less/style.less";

import Booking from "./js/booking/booking";
import Carousel from "./js/carousel/carousel";
import Cookies from "./js/cookies/cookies";
import FaqForm from "./js/faq-form/faq-form";
import Helpers from "./js/helpers/helpers";
import Navigation from "./js/nav/nav";
import Notify from "./js/notify/notify";
import Remind from "./js/remind/remind"
import TestBooking from "./js/test-booking/booking"

// Google Maps
import Map from "./js/map/index"
import FilterMapResults from "./js/ajax/filterMapResults"

if (module.hot) {
  module.hot.accept();
}

const $ = jQuery;

Booking($).init();
Carousel($).init();
Cookies($).init();
FaqForm($).init();
Helpers($).init();
Map().init();
FilterMapResults($).init();
Navigation($).init();
Notify().init();
Remind().init();
TestBooking().init();


// console.log("Parcel is Working!");

if ( typeof acf !== 'undefined' ) {
  acf.add_filter('validation_complete', function (json, $form) {
    if ( json.valid && ! json.errors ) {
      console.debug('json',json)
    } else {
      console.error(json.errors)
    }

    // return
    return json;
  });
}
